/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddRole.scss';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import ModalAlert from '../../../ModalAlert';
import { addRole, deleteRole } from '../../../../../actions/district';
import fetch from '../../../../../core/fetch';


const ModalConfirm = (props) => {
  return (
    <Modal {...props} >
      <Modal.Header className="bg-warning" closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.bodyText}
        <br /><br />
        <Button className="btn btn-default pull-right" onClick={props.onHide}>Anuluj</Button>
        <Button className="btn btn-warning pull-right" onClick={props.confirm}>OK</Button>
        <br /><br />
      </Modal.Body>
    </Modal>
  );
};

const fastStyleMargin = {
  marginTop: '7px',
};

const leftMargin = {
  marginLeft: '20px',
  marginTop: '7px',
}

class AddRole extends React.Component {
  constructor(props) {
    super(props);
    const startService = 'WMS';
    this.state = {
      showModal: false,
      showConfirm: false,
      modalTitle: '',
      modalBody: '',
      nazwa: '',
      isDefault: false,
    };
  }

  onConfirm = () => {}
  dismissModal = () => this.setState({ showModal: false });
  dismissConfirm = () => this.setState({ showConfirm: false });
  onChangeIsDefault = (e) => this.setState({ isDefault: e.target.value });
  onChangeNazwa = (e) => this.setState({ nazwa: e.target.value });

  add = () => {
    if (!this.state.nazwa) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij pola formularza', showModal: true });
    } else {
      this.props.addRole(this.props.district.prefix, this.state.nazwa, this.state.isDefault)
      .then((resp) => {
        if (resp.status === 200) {
          this.setState({ nazwa: '', modalTitle: 'Status', modalBody: 'Pomyślnie dodano dodano rolę.', showModal: true });
        } else {
          this.setState({ nazwa: '', modalTitle: 'Status', modalBody: resp.message, showModal: true });
        }
      })
      .catch((error) => {
        return error;
      }).then((error) => {
        if (error !== undefined) {
          this.setState({ nazwa: '', modalTitle: 'Błąd', modalBody: error.message, showModal: true });
        }
      });
    }
  }
  delete = (nazwa) => {
    this.props.deleteRole(this.props.district.prefix, nazwa)
    .then((resp) => {
      if (resp.status === 200) {
        this.setState({ nazwa: '', modalTitle: 'Status', modalBody: 'Pomyślnie usunięto rolę.', showModal: true });
      } else {
        this.setState({ nazwa: '', modalTitle: 'Status', modalBody: resp.message, showModal: true });
      }
    })
    .catch((error) => {
      return error;
    }).then((error) => {
      if (error !== undefined) {
        this.setState({ nazwa: '', modalTitle: 'Błąd', modalBody: error.message, showModal: true });
      }
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      isDefault: value,
    });
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="form-inline">
            <label htmlFor="nazwa" className="col-xs-3" style={fastStyleMargin}>Nazwa</label>
            <input name="nazwa" type="text" className="form-control" value={this.state.nazwa} onChange={(e) => this.onChangeNazwa(e)} />
          </div>
          <div className="form-inline">
            <label style={leftMargin}>
              <input
                name="isDefault"
                type="checkbox"
                checked={this.state.isDefault}
                onChange={this.handleInputChange}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;Czy jest rolą domyślna dla nowych użytkowników zewnętrznych ?
            </label>
          </div>
          <button type="button" className="btn btn-info" onClick={() => this.add()}>Dodaj</button>
        </div>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        <ModalConfirm
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showConfirm}
          confirm={this.onConfirm}
          onHide={this.dismissConfirm}
        />

        <div className="row">
          <br /> <br />

          <h4>Dodanych ról: </h4>
          <hr />
          <table className="table">
            <thead>
              <tr>
                <th>Nazwa</th>
                <th>Domyślna</th>
                <th>Akcje</th>
              </tr>
            </thead>
            <tbody>
              {this.props.district.roles.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{v.nazwa}</td>
                    <td><input type="checkbox" checked={v.isDefault} disabled /></td>
                    <td><button type="button" className="btn btn-danger" onClick={() => this.delete(v.nazwa)}>Usuń</button></td>
                  </tr>);
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  addRole,
  deleteRole,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddRole));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddRole/AddRole.js